<template>
  <div>
    <whats-app-fixed></whats-app-fixed>
    <other-components-header></other-components-header>
    <div class="allContainer">
      <div class="titleContainer">
        <p class="title">{{ $store.state.service.serviceName }}</p>
      </div>
      <div class="stepContainer">
        <router-link to="/thirdyStep" class="setaStep"
          ><img src="@/assets/stepsImages/setaStep.svg"
        /></router-link>
        <div class="lastStep">
          <img src="@/assets/stepsImages/lastStep.svg" class="lastStepImg" />
        </div>
      </div>
      <div class="payInfoContainer">
        <p class="payInfo"><strong>Pagamento realizado!</strong></p>
      </div>
      <div class="statusPayContainer">
        <p class="statusPay">Aguarde que nosso time concluirá o seu serviço!</p>
      </div>
      <div class="transitionContainer">
        <div class="idTransitionContainer">
          <p class="idTransition">
            ID da Transação: <strong id="idTransitionTxt"> {{ $store.getters.getQRCodeStore.orderId }} </strong>
          </p>
        </div>
        <div class="buttonTransitionContainer">
          <button class="buttonTransition" type="submit" @click="copyIdTxt">
            Copiar
          </button>
        </div>
        <div class="orangeVIconContainer">
          <img src="@/assets/stepsImages/orangeVIcon.png" class="orangeVIcon" />
        </div>
      </div>
      <div class="consultContainer">
        <p class="consultText">Use este número para consultar o andamento</p>
      </div>
      <div class="buttonTransitionContainerMobile">
        <button class="buttonTransitionMobile" type="submit" @click="copyIdTxt">
          Copiar ID
        </button>
      </div>
      <div class="infoContainer">
        <div class="infoText">
          <p class="information" id="infoOne">
            <strong>Serviço:</strong> {{ $store.state.service.serviceName }}
          </p>
          <p class="information">
            <strong>Valor pago:</strong> R$
            {{ $store.state.service.serviceValue }}
          </p>
          <p class="information">
            <strong>Instituição:</strong> BCO do Brasil S.A
          </p>
          <p class="information" id="infoLast">
            <strong>Data do pagamento:</strong>
            {{ $store.state.service.atualDate }}
          </p>
          <p class="information">
            <strong>Nome:</strong> {{ $store.state.service.nameUser }}
          </p>
        </div>
        <div class="infoTextTwo" style="display: none">
          <p class="information" id="infoOne">
            <strong>Email:</strong> {{ $store.state.service.emailUser }}
          </p>
          <p class="information">
            <strong>Telefone:</strong> {{ $store.state.service.telUser }}
          </p>
          <p class="information">
            <strong>CPF:</strong> {{ $store.state.service.cpfUser }}
          </p>
          <p class="information" id="infoLast">
            <strong>Endereço:</strong> {{ $store.state.service.endUser }},
            {{ $store.state.service.city }} {{ $store.state.service.state }}
          </p>
          <p class="information"><strong>ID do Serviço:</strong> {{ $store.getters.getQRCodeStore.orderId }}</p>
        </div>
        <div class="saveInfoContainer">
          <div class="saveInfo">
            <button @click="printoToPdf" type="submit" class="saveButton">
              Salvar Comprovante
              <img src="@/assets/stepsImages/saveInfo.svg" />
            </button>
          </div>
          <img
            src="../../assets/onlyMobileImg/mobileLogo.png"
            class="teste"
            style="display: none"
          />
        </div>
      </div>
      <div class="consultTextContainer">
      </div> 
      <div class="buttonToFollow">
        <router-link to="/search" class="followButton">
          Acompanhar Pedido
          <img src="@/assets/headerImages/lupa.svg" />
        </router-link>
      </div>
    </div>
    <div>
      <footer-in-footer></footer-in-footer>
    </div>
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
import whatsAppFixed from "@/utils/whatsAppFixed.vue";
import otherComponentsHeader from "@/components/Header/otherComponentsHeader.vue";
import footerInFooter from "@/components/Footer/footerInFooter.vue";
export default {
  components: {
    otherComponentsHeader,
    footerInFooter,
    whatsAppFixed,
  },
  data() {
    return {
      dataAtual: "",
      endereço: "",
    };
  },
  methods: {
    copyIdTxt() {
      let textCopy = document.getElementById("idTransitionTxt");
      navigator.clipboard.writeText(textCopy.innerHTML).then(() => {
        let orangeIcon = document.querySelector(".orangeVIconContainer");
        orangeIcon.style.display = "block";
      });
    },
    date() {
      const data = new Date();
      const dia = String(data.getDate()).padStart(2, "0");
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const ano = data.getFullYear();
      this.dataAtual = `${dia}/${mes}/${ano}`;
      this.selectedData();
    },
    selectedData() {
      this.$store.commit("dataAtual", { data: this.dataAtual });
    },
    printoToPdf() {
      this.endereço = this.$store.state.service.endUser;
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "in",
        format: [10, 10],
      });
      const logo =
        "data:image/png;base64,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";
      doc.addImage(logo, "PNG", 0.5, 0.5, 3, 0.4);
      doc.setFontSize(22);
      doc.text("Comprovante de Pagamento.", 0.5, 2);
      doc.setFontSize(16);
      doc.setTextColor(0, 255, 0);
      doc.text("Pagamento Realizado!", 0.5, 3);
      doc.setFontSize(14);
      doc.setTextColor(50);
      doc.text("Nome: " + this.$store.state.service.nameUser, 0.5, 3.7);
      doc.text("Email: " + this.$store.state.service.emailUser, 0.5, 4);
      doc.text("Telefone: " + this.$store.state.service.telUser, 0.5, 4.3);
      doc.text("CPF: " + this.$store.state.service.cpfUser.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"), 0.5, 4.6);
      doc.text(
        "Endereço: " +
          this.$store.state.service.endUser +
          " " +
          this.$store.state.service.city +
          " " +
          this.$store.state.service.state,
        0.5,
        4.9
      );
      doc.text("Serviço: " + this.$store.state.service.serviceName, 0.5, 5.2);
      doc.text("Valor: R$" + this.$store.state.service.serviceValue, 0.5, 5.5);
      doc.text("Instituição: BCO do Brasil S.A", 0.5, 5.8);
      doc.text(
        "Data do Pagamento: " + this.$store.state.service.atualDate,
        0.5,
        6.1
      );
      doc.text("ID do Pedido: " + this.$store.getters.getQRCodeStore.orderId, 0.5, 6.4);
      doc.addImage(logo, "PNG", 0.5, 9, 2, 0.3);
      doc.save("ComprovantePontoFácil.pdf");
    },
  },
  mounted() {
    this.date();
  },
};
</script>

<style scoped>
@media screen and (min-width: 601px) {
  .buttonTransitionMobile {
    display: none !important;
  }
}
@media screen and (max-width: 600px) {
  .buttonTransition {
    display: none !important;
  }
  .followButton {
    width: 100% !important;
    height: 34px !important;
  }
  .titleContainer {
    width: 73% !important;
  }
  .title {
    font-size: max(1.3vw, 20px) !important;
  }
  .lastStep {
    margin-right: 4% !important;
    width: 80% !important;
  }
  .lastStepImg {
    width: 90% !important;
  }
  .setaStep {
    margin-right: 9% !important;
  }
  .payInfo {
    font-size: max(1.1vw, 17px) !important;
    margin-top: 10%;
    margin-bottom: 20%;
  }
  .statusPay {
    font-size: max(1.6vw, 25px) !important;
  }
  .consultText[data-v-10593f8a] {
    font-size: max(1vw, 14px);
    margin-bottom: 11px !important;
  }
  .idTransition {
    font-size: max(2.4vw, 13px) !important;
  }
  .idTransitionContainer {
    margin-left: 69% !important;
    min-width: 100% !important;
  }
  .transitionContainer {
    background: #ffff !important;
    justify-content: center !important;
    border: 1px #d3d3d3 solid !important;
    opacity: 0.8 !important;
    border-radius: 23px !important;
    width: 42% !important;
    height: 37px !important;
    display: flex !important;
    align-items: center !important;
    margin-top: 1% !important;
  }
  .infoContainer {
    display: flex !important;
    justify-content: center !important;
    margin-top: 2% !important;
    border: 1px solid #e9e9eb !important;
    border-radius: 12px !important;
    width: 90% !important;
    flex-direction: column !important;
    padding-top: 1.4% !important;
    padding-bottom: 0.4% !important;
    margin-top: 6% !important;
  }
  .infoText {
    width: 100% !important;
  }

  .saveInfo {
    width: 90% !important;
    display: flex !important;
    justify-content: center !important;
    margin-right: 2% !important;
    margin-top: 0.8% !important;
    align-items: center !important;
    margin-top: 3% !important;
    border-top: 1px #e9e8e8 solid;
  }
  .saveInfoContainer {
    width: 100% !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  .information {
    font-size: max(0.9vw, 13px) !important;
  }
}
@media screen and (max-width: 520px) {
  .transitionContainer {
    justify-content: flex-start !important;
  }
  .idTransitionContainer {
    margin-left: 4% !important;
    min-width: 100% !important;
  }
}
@media screen and (max-width: 450px) {
  .titleContainer {
    width: 95% !important;
  }
}
@media screen and (max-width: 420px) {
  .lastStep {
    margin-right: -6% !important;
    width: 80% !important;
  }
  .lastStepImg {
    width: 82% !important;
  }
  .setaStep {
    margin-right: 6% !important;
  }
  .buttonTransitionMobile {
    width: 27% !important;
    height: 26px !important;
  }
}
@media screen and (max-width: 344px) {
  .transitionContainer {
    width: 45% !important;
  }
}
@media screen and (max-width: 335px) {
  .title {
    font-size: max(1.3vw, 16px) !important;
  }
  .transitionContainer {
    width: 55% !important;
  }
}
.orangeVIconContainer {
  width: 20px;
  max-width: 20px;
  display: none;
}
.orangeVIcon {
  width: 20px;
  padding-bottom: 5px;
}
.title {
  margin: 0;
}
.titleContainer {
  margin-bottom: 3%;
  display: flex;
  justify-content: center;
  background: #f7f7fb;
  border-radius: 24px;
  width: 30%;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 45px;
  text-align: center;
  color: #465eff;
  height: 50px;
}
.allContainer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3%;
  flex-direction: column;
}
.stepContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2%;
}
.lastStep {
  margin-right: 43%;
}
.setaStep {
  margin-right: 43%;
}
.title {
  font-size: max(1.3vw, 12px);
}
@media screen and (max-width: 800px) {
  .setaStep {
    margin-right: 20%;
  }
  .lastStep {
    margin-right: 20%;
  }
}
.payInfoContainer {
  margin-top: 2%;
}
.payInfo {
  font-style: normal;
  font-weight: 600;
  font-size: max(1.1vw, 12px);
  line-height: 24px;
  text-align: center;
  color: #1e59ae;
}

.infoContainer {
  display: flex;
  justify-content: center;
  margin-top: 2%;
  border: 1px solid #e9e9eb;
  border-radius: 12px;
  width: 40%;
  flex-direction: row;
  padding-top: 0.4%;
  padding-bottom: 0.4%;
}

.statusPay {
  font-style: normal;
  font-weight: 600;
  font-size: max(1.6vw, 15px);
  line-height: 36px;
  text-align: center;
  color: #f38235;
}
.transitionContainer {
  background: #e9e9eb;
  opacity: 0.8;
  border-radius: 23px;
  width: 30%;
  height: 51px;
  display: flex;
  align-items: center;
  margin-top: 1%;
}
.idTransition {
  font-style: normal;
  font-weight: 400;
  margin: 0;
  font-size: max(1.4vw, 14px);
  line-height: 30px;
  color: #383843;
}
.idTransitionContainer {
  margin-left: 4%;
  min-width: 70%;
}
.buttonTransition {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: #ffa620;
  border-radius: 30px;
  font-style: normal;
  font-weight: 600;
  font-size: max(1.2vw, 11px);
  line-height: 113.2%;
  color: #ffffff;
  flex: none;
  order: 0;
  flex-grow: 0;
  border: none;
  width: 80%;
  height: 37px;
}
.buttonTransition:hover {
  background: #f99500;
  transition: 0.7s;
}
.buttonTransitionContainerMobile {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 7%;
}
.buttonTransitionMobile {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: #ffa620;
  border-radius: 30px;
  font-style: normal;
  font-weight: 600;
  font-size: max(1.2vw, 14px);
  line-height: 113.2%;
  color: #ffffff;
  flex: none;
  order: 0;
  flex-grow: 0;
  border: none;
  width: 22%;
  height: 23px;
}
.buttonTransitionMobile:hover {
  background: #f99500;
  transition: 0.7s;
}
.buttonTransitionContainer {
  min-width: 25%;
  display: flex;
  float: right;
  margin-left: 5%;
}
.consultText {
  font-style: normal;
  font-weight: 400;
  font-size: max(1vw, 8px);
  line-height: 18px;
  color: #4c4d5b;
}
.consultContainer {
  margin-top: 0.5%;
}
.information {
  margin: 0;
  font-style: normal;
  font-weight: 500;
  font-size: max(0.9vw, 8px);
  line-height: 21px;
  color: #797984;
  margin-top: 1%;
  margin-bottom: 1%;
  margin-left: 4%;
}
@media screen and (min-width: 2200px) {
  .information {
    margin-top: 3%;
    margin-bottom: 3%;
  }
}
@media screen and (max-width: 800px) {
  .information {
    margin-top: 0%;
    margin-bottom: 0%;
  }
}

.infoText {
  width: 50%;
  margin-right: 15%;
}
.saveInfo {
  display: flex;
  align-items: baseline;
  justify-content: end;
  margin-top: 6%;
}
.saveButton {
  font-style: normal;
  font-weight: 500;
  font-size: max(1vw, 10px);
  line-height: 18px;
  color: #1e59ae;
  background-color: #ffff;
  border: none;
}
.consultTextContainer {
  margin-top: 4%;
}
.consultTextTwo {
  font-style: normal;
  font-weight: 400;
  font-size: max(1.2vw, 13px);
  line-height: 24px;
  text-align: center;
  color: #797984;
}
.followButton {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 15px 22px;
  gap: 2px;
  background: #71a1ff;
  border-radius: 30px;
  font-style: normal;
  font-weight: 600;
  font-size: max(1.2vw, 13px);
  line-height: 113.2%;
  color: #ffffff;
  flex: none;
  order: 0;
  flex-grow: 0;
  text-decoration: none;
}
.followButton:hover {
  background: #225bce;
  transition: 0.7s;
}
.buttonToFollow {
  margin-bottom: 1%;
}
</style>
